import React from "react";
import { Container, Row, Col, Form as BSForm } from "react-bootstrap";
import { motion } from "framer-motion";
import "./form.css";

const Form = () => {
  return (
    <div className="contact-section">
      <Container>
        {/* Heading */}
        <motion.h2
          className="contact-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Get In Touch
        </motion.h2>

        <motion.p
          className="contact-subtitle"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Connect with our team by completing the form below, and we’ll guide
          you toward the best solutions for your space.
        </motion.p>

        {/* Form */}
        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <BSForm className="contact-form">
            <Row className="mb-3">
              <Col md={6}>
                <BSForm.Control
                  type="text"
                  placeholder="First Name"
                  className="form-input"
                />
              </Col>

              <Col md={6}>
                <BSForm.Control
                  type="text"
                  placeholder="Last Name"
                  className="form-input"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <BSForm.Control
                  type="email"
                  placeholder="Email Address"
                  className="form-input"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <BSForm.Control
                  type="text"
                  placeholder="Phone"
                  className="form-input"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <BSForm.Control
                  type="text"
                  placeholder="Company Name"
                  className="form-input"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <BSForm.Select className="form-input">
                  <option>Investor</option>
                  <option>Client</option>
                  <option>Startup Founder</option>
                  <option>Partner</option>
                </BSForm.Select>
              </Col>
            </Row>

            <Row>
              <Col>
                <BSForm.Control
                  as="textarea"
                  rows={5}
                  placeholder="Your Message"
                  className="form-input"
                />
              </Col>
            </Row>

            <div className="text-center mt-4 mb-5">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ duration: 0.2 }}
                className="send-btn"
              >
                Send Inquiry
              </motion.button>
            </div>
          </BSForm>
        </motion.div>
      </Container>
    </div>
  );
};

export default Form;


